import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';

import { Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { SelfService } from '../self-services.service.ts';
import { LandingPaginationDTO } from "../../bpg-common/services/data.services";
import { BpgCommonService } from '../../bpg-common/services/bpg-common.service';
import { ConstantValues } from '../../bpg-common/models/bpg-constants';
import { UploadService } from './upload.service';
import { ImageCroppedEvent } from 'ngx-image-cropper';



@Component({
  selector: 'app-d-i',
  templateUrl: './d-i.component.html',
  styleUrls: ['./d-i.component.css']
})


export class DIComponent implements OnInit {

  /**
  * @class DIComponent
  * @constructor
  */
  constructor(
    private readonly userService: SelfService,
    private readonly router: Router,
    private readonly spinnerService: Ng4LoadingSpinnerService,
    private readonly diService: SelfService,
    private readonly environment: EnvironmentConfiguration,
    private readonly bpgCommonService: BpgCommonService,
    private readonly uploadService: UploadService) { }

  @ViewChild('myInput', { static: false })
  myInputVariable: ElementRef;
  @ViewChild('myInputBanner', { static: false })
  myInputBannerVariable: ElementRef;
  method: string;
  param: string;
  param1: string;

  msg1: string;
  editandSavebtn = false;
  savebtn = false;
  adminId: any = localStorage.getItem('adminId');
  loginDetails: any = JSON.parse(localStorage.getItem("loginData"));
  loginUserId:any = this.loginDetails['userId'];
  diMasterTable = true;
  diNewsTable = false;
  diResourceTable = false;
  diReTeamTable = false;
  diNaacTable = false;

  bannerName: string;
  aboutDesc = "";
  naacDesc: string;
  diBanner: string;

  newsTitle: string;
  newsDesc: string;
  newsLink: string;
  newsImage: string;
  isUploadnewsImage = false;
  isLoadernewsImageStop = false;
  newsFile: File;
  fileTypeConstant = 'JPEG or PNG';
  selectedFileNameforNews: string = this.fileTypeConstant;
  newsfileName = '';
  newsExtensionError = false;


  addResouceTitle: string;
  additionalDesc: string;
  addResourceDocument: string;
  resourceOrder: number;

  regionalDesignation: string;
  userId: number;
  name: string
  emailId: string;
  userPic: string;
  userFirstName: string;
  reTeamOrder: number;
  diPronoun: string;
  siteList: any = [];
  siteName: any = [];
  siteNameList: any = [];

  naacName: string;
  naacLogo: string;
  naacLink: string;

  searchTerm: any;
  LandingPaginationDTO: LandingPaginationDTO = new LandingPaginationDTO();
  userList: any;
  noUser: boolean;
  search: boolean;
  userFound: boolean;
  diMasterList: any;
  limit: number = ConstantValues.pageLimit;
  currentShowingElementsNews: number = ConstantValues.pageLimit;
  currentShowingElementsResource: number = ConstantValues.pageLimit;
  currentShowingElementsReTeam: number = ConstantValues.pageLimit;
  currentShowingElementsNaac: number = ConstantValues.pageLimit;

  tableShow: boolean;
  numberOfElements: any;
  diNewsList: any;
  diResouceList: any;
  diReTeamList: any;
  naacAffiliateList: any
  uploadFileExtensionBanner = false;
  uploadFileExtensionUser = false;
  uploadFileExtensionNaac = false;
  uploadImageDone = false;
  isLoaderStop = false;
  isUploadImage = false;

  fileNameList: any = [];

  croppedbannerImage: any;

  fileExtensionCount = 0;
  noDataFound: boolean;
  bannerResponseList: any;
  deleteSuccess = false;

  uploadUserPicImageDone = false;
  isLoaderUserPicStop = false;
  isUploadUserPicImage = false;

  width: number;
  height: number;
  lbl: any;
  RePic: any;
  naacLog: any;
  diBannerImage: string = null;
  currentPage = 0;
  lbl2: any


  diUpdateSuccess = false;
  diNewsSuccess = false;
  diResourceSuccess = false;
  diReteamSuccess = false;
  diNaacSuccess = false;

  newsSearchKey: any;
  reTeamSearchKey: any;
  resourceSearchKey: any;
  naacSearchKey: any;

  noNewsTable = false;
  noResourceTable = false;
  noReginalTbale = false;
  noNaacTable = false;

  deleteNews = false;
  deleteResource = false;
  deleteRegional = false;
  deleteNaac = false;

  di: any;
  order: number;

  uploadFileName: string = null;
  uploadFileNameUser: string = null;
  uploadFileNameNaac: string = null;

  diNaacBannerImage: string = null;
  showReset = false;
  diUserImage: string = null;
  logoPathImage: string = null;

  errorMessageResourceActive = false;
  errorMessageResource: any;
  errorMessageRegionalActive = false;
  errorMessageRegional: any;

  firstEditNews = true;
  firstEditResource = true;
  firstEditReTeam = true;
  firstEditNaac = true;

  saveAndUpdateNews = false;
  saveNews = true;
  saveResource = true;
  saveAndUpdateResource = false;
  saveReTeam = true;
  saveAndUpdateReTeam = false;
  saveNaac = true;
  saveAndUpdateNaac = false;
  saveMasterBtn = false;


  newsId: string;
  diId: string;
  diResourceId: string;
  diReTeamId: string;
  naacId: string;
  newsLinkValid = false;
  naacLinkValid = false;
  reTeamEamilValid = false;

  ResourcefileName = "Upload document(< 500MB)";
  fileSize: number;
  fileExtension: any;
  fileSizeExtensionError = false;
  selectedFile: File = null;
  UploadDocument: any;
  isuploaded = true;
  fileList: File[] = [];
  timeOutError = false;
  isFileUploded = false;
  reTeamFlag: any;
  naacFlag: any;

  timeoutErrorMessage: string = ConstantValues.timeoutErrorMessage;

  failureOnResourceUpload = false;
  butDisabled = true;
  awsUrls: any;
  resourceData: any;

  uploadFlag: any;

  errorMsgUploadSave = false;
  errorMsgUploadSaveUpdate = false;

  folderNameList: any = [];
  selectedFolder: string;
  landingData: any;
  folderId: number;
  folderName: string;

  //Image Cropper
  imageChangedEvent: any = '';
  imageChangedEventBanner: any = '';
  croppedImage: any = '';
  imageTypeName: string = null;

  removeToolbar: any = { toolbar: 'Basic', uiColor: '#FFFFFF', basicEntities: false, fillEmptyBlocks: false, removeButtons: 'Source,Save,NewPage,Preview,Print,Templates,Pasteas plain text,PastefromWord,Find,Replace,SelectAll,Form,Checkbox,Radio,TextField,Textarea,SelectionField,Button,ImageButton,HiddenField,Italic,Decrease,Increase,Block,Create Div Container,Text direction from left to right,Text direction from right to left,Set language,Link,Unlink,Image,Flash,Table,Horizontal,Smiley,Insert Special Character,Insert Page Break for Printing,IFrame,Formatting,Paragraph,Font,FontSize,TextColor,BackgroundColor,Maximize,ShowBlocks,About,forceSpellChecker,Cut,Copy,Paste,Undo,Redo,Anchor,Underline,Strike,Subscript,Superscript,Bold,RemoveFormat' }
  msg1Constant = " Are you sure you want to update ? ";
  dataToggleConstant = 'data-toggle';
  dataTargetConstant = 'data-target';
  msgConstant = " Are you sure you want to Save ? ";
  msg2Constant = " Your current changes will be discarded, do you want to continue ? ";
  fileType1Constant = "image/jpeg";
  ngOnInit() {
    if (this.environment.envName === 'dev' || this.environment.envName === 'qa' || this.environment.envName === 'prod') {
              if (localStorage.getItem('loginData')=== null || localStorage.getItem('loginData')=== undefined) {

        this.router.navigate(['/log-out']);
      }
    }
    localStorage.removeItem('searchedEventsCaledarItems');
    if (this.adminId !== '1') {
      this.router.navigate(['/site-home']);
    }
    this.bpgCommonService.getSessionToken();
    this.saveMasterBtn = true;
    this.diId = '0';
    this.logUserAction();
    this.getDiMasterList();
    this.getdiBannerList();
    this.getallSite();
    this.imageChangedEvent = '';
    this.imageChangedEventBanner = '';
    this.croppedImage = '';
    this.uploadFileName = '';
    this.uploadFileExtensionUser = false;
    document.getElementById("base64textareaUser").textContent = '';
    document.getElementById("filenameUserPic").textContent = this.fileTypeConstant;
    this.myInputVariable.nativeElement.value = '';
    document.getElementById("base64textarea").textContent = '';
    document.getElementById("filenameBanner").textContent = this.fileTypeConstant;
    this.myInputBannerVariable.nativeElement.value = '';
    this.isUploadImage = false;
    this.isLoaderStop = false;
    this.diUserImage = null;
    this.uploadImageDone = false;
    this.uploadUserPicImageDone = false;
    this.isLoaderUserPicStop = false;
    this.isLoadernewsImageStop = false;
    this.isUploadUserPicImage = false;


  }

  /** To get Di Master Data
    * @class DIComponent
    * @method getDiMasterList
    */
  getDiMasterList() {
    this.spinnerService.show();
    this.LandingPaginationDTO.size = ConstantValues.pageLimit;
    this.LandingPaginationDTO.sortDirection = "ASC";
    this.LandingPaginationDTO.sortProperty = "diName";
    this.LandingPaginationDTO.filter = { "diFlag": "diSelfService" }
    this.diService.getDiMasterList(this.LandingPaginationDTO).subscribe(data => {
      this.diMasterList = data.content;
      this.spinnerService.hide();
    })


  }

  /** get all site list
   * @class allSite
   * @method   getallSite(){

   */
  getallSite() {
    this.userService.getAllSite().subscribe(data => {
      this.siteList = data;
    })
  }
  /** get banner image list
   * @class BannerImage
   * @method getdiBannerList
   */
  getdiBannerList() {
    this.spinnerService.show();

    this.LandingPaginationDTO.size = 50;
    this.LandingPaginationDTO.filter = { "diFlag": "diSelfService" }
    this.userService.getdiBannerList(this.LandingPaginationDTO).subscribe(data => {
      this.bannerResponseList = data.content;
      this.deleteSuccess = false;
      this.spinnerService.hide();
      this.numberOfElements = data.totalElements;

      if (this.bannerResponseList.length === 0){
        this.noDataFound = true;
      }
      else {
        this.noDataFound = false;
      }
    });
  }




  /** to clear data
   * @class DIComponent
   * @method clearAlerts
   */
  clearAlerts() {
    this.noUser = false;
    this.userFound = false;

  }

  /** to list users other than admins
  * @class DIComponent
  * @method getUserList
  */
  getUserList() {
    this.diReteamSuccess = false;
    this.deleteRegional = false;
    this.LandingPaginationDTO.filter = { "leadershipPosition": "USER" };
    this.diService.getUserDropDown(this.LandingPaginationDTO).subscribe(data => {
      this.userList = data;
      if (this.userList.length === 0) {
        setTimeout(() => {
          window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        }, 500);
        this.noUser = true;
        this.userFirstName = null
        this.emailId = null
        this.butDisabled = true;

      } else {
        this.butDisabled = false;

        if (this.search) {
          setTimeout(() => {
            window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
          }, 500);
          this.userFound = true;

        }
        this.userList.map((i) => { i.userFirstName = `${i.userFirstName} ${i.userLastName}`; return i; })
      }

    }, _err => {
    });


  }

  /** to select the user acc to serach
  * @class DIComponent
  * @method userSelection
  */
  userSelection(user) {
    this.userFound = false;
    for (const use of this.userList) {

      if (use != null) {
        if (user.userId === use.userId) {
          this.userId = use.userId;
          this.name = use.userFirstName;
          this.emailId = use.emailId;
          this.reTeamEamilValid = false;
        }
      }
    }

  }

  /** to sumbit di master
  * @class DIComponent
  * @method onDiMasterSubmit
  */
  public onDiMasterSubmit() {
    if (this.uploadFileExtensionBanner === true) {
      this.removeModal();
      return;
    }
    if (this.saveMasterBtn === true) {
      this.setModal();
      this.popupModal()
      document.getElementById('masterSave').click();
    }

  }

  popupModal() {
    this.method = "saveMaster";
    this.param = '';
    this.msg1 = this.msg1Constant;
  }

  setModal() {
    document.getElementById('masterSave').setAttribute(this.dataToggleConstant, 'modal');
    document.getElementById('masterSave').setAttribute(this.dataTargetConstant, '#myModal');
  }
  removeModal() {
    document.getElementById('masterSave').removeAttribute(this.dataToggleConstant);
    document.getElementById('masterSave').removeAttribute(this.dataTargetConstant);
  }


  /** to delete news Image
     * @class DIComponent
     * @method removeFile
     */
  removeFile() {
    this.diNewsSuccess = false;
    this.newsSearchKey = null
    this.newsLinkValid = false
    this.LandingPaginationDTO.searchTerm = '';
    this.selectedFileNameforNews = this.fileTypeConstant;
    this.isUploadnewsImage = false;
    this.newsFile = null;
    this.newsfileName = '';
    this.newsExtensionError = false;

  }

 


  /** to submit news
  * @class DIComponent
  * @method onNewsSubmit
  */
  public onNewsSubmit() {

    if (this.saveAndUpdateNews === true) {
      this.method = "addNews";
      this.param = '';
      this.msg1 = this.msg1Constant;
    }
    else {
      this.method = "addNews";
      this.param = '';
      this.msg1 = this.msgConstant;
    }
  }

  /** to save/update news
  * @class DIComponent
  * @method addNews
  */
  addNews() {
    this.spinnerService.show();
    const uploadData =
    {
      'category': 'uploadDocument',
    }
    if (!this.isUploadnewsImage){
      this.newsfileName = '';
    }

    const diData = {
      "diNewsTitle": this.newsTitle,
      "diNewsDesc": this.newsDesc,
      "diNewsLink": this.newsLink,
      "id": this.loginDetails.userId,
      "diId": this.diMasterList[0].diId,
      "diNewsId": this.newsId,
      "newsImage": this.newsfileName,
      "imageCheck": this.isUploadnewsImage
    }
    this.diService.diAddNews(diData).subscribe(data => {
      if (data !== undefined) {
        this.deleteNews = false;
        this.diNewsSuccess = true;
        const newsImageName = data.diNewsName;
        this.uploadFlag = 'news';
        if (this.newsFile != null) {
          this.bpgCommonService.getAwsUrl(uploadData).subscribe(async data => {
            this.awsUrls = data;
            await this.uploadService.getPresignedUrl(this.newsFile, this.awsUrls, newsImageName, this.uploadFlag);
            if (localStorage.getItem('uploadError') === 'Error') {
              this.errorMsgUploadSave = true;
            }
            else {
              this.diNewsSuccess = true;
              this.getDiNewsList();
            }
          });
        }
        else {
          this.diNewsSuccess = true;
          this.getDiNewsList();
        }
        setTimeout(() => {
          window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        }, 200);
        this.spinnerService.hide();
      }
    });
  }

  /** to submit resource
 * @class DIComponent
 * @method onResourceSubmit
 */
  public onResourceSubmit() {
    if (this.saveAndUpdateResource === true) {
      this.method = "addResource";
      this.param = '';
      this.msg1 = this.msg1Constant;
    }
    else {
      this.method = "addResource";
      this.param = '';
      this.msg1 = this.msgConstant;
    }
  }
  /** to submit resource
  * @class DIComponent
  * @method onResourceSubmit
  */
  public onDiMasterSubmitBanner() {

    this.method = "addBanner";
    this.param = '';
    this.msg1 = this.msg1Constant;
  }

  public addBanner() {

    const bannerData = {
      "diId": 0,
      "id": this.loginDetails.userId,
      "diBanner": this.uploadFileName,
      "diBannerImage": this.diBannerImage
    }

    this.diService.diAddMaster(bannerData).subscribe(response => {
      if (response.body.message === 'Error') {
        this.errorMsgUploadSave = true;
      }
      else {
        this.diUpdateSuccess = true;
        this.cancelUploadedImage('bannerImage')
        this.getdiBannerList();
     
      }
    });


  }





  /** to save/update resource
* @class DIComponent
* @method addResource
*/
  public addResource() {
    this.spinnerService.show();
    const uploadData =
    {
      'category': 'uploadDocument',
    }
    this.uploadFlag = 'resource';
    const diData = {
      "diResourceTitle": this.addResouceTitle,
      "diResourceDesc": this.additionalDesc,
      "diResourceDocument": this.UploadDocument,
      "id": this.loginDetails.userId,
      "resourceOrder": this.resourceOrder,
      "diId": this.diMasterList[0].diId,
      "diResourceId": this.diResourceId,
      "folderId": this.selectedFolder
    }
    //for edit case
    if (this.saveAndUpdateResource === true) {
      if (this.selectedFile != null) {
        this.spinnerService.show();

        this.bpgCommonService.getAwsUrl(uploadData).subscribe(async data => {
          this.awsUrls = data;
          await this.uploadService.getPresignedUrl(this.selectedFile, this.awsUrls, this.diResourceId, this.uploadFlag);

          if (localStorage.getItem('uploadError') === 'Error') {
            this.errorMessageResourceActive = false;
            this.errorMsgUploadSaveUpdate = true;
            this.diResourceSuccess = false;
            this.getDiResouceList();
            this.getDiFolderList();

            setTimeout(() => {
              window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
            }, 200);
            this.spinnerService.hide();
            localStorage.removeItem('uploadError')
          }
          else {

            this.diService.diAddResource(diData).subscribe(data => {
              this.resourceData = data;
              this.uploadFlag = 'resource';
              if (data.message !== undefined) {
                this.errorMessageResource = data.message;
                this.errorMessageResourceActive = true;
                this.errorMsgUploadSaveUpdate = false;
                this.diResourceSuccess = false;
                setTimeout(() => {
                  window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
                }, 200);
              }
              else if (data !== undefined) {
                this.spinnerService.show();
                this.errorMessageResourceActive = false;
                this.diResourceSuccess = true;
                this.deleteResource = false;
                this.errorMsgUploadSaveUpdate = false;
                this.getDiResouceList();
                this.getDiFolderList();
                this.spinnerService.hide();

                setTimeout(() => {
                  window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
                }, 200);

              }
            });
          }
        });
      }
      else {
        //edit no files selected
        this.spinnerService.show();
        this.diService.diAddResource(diData).subscribe(data => {
          if (data.message !== undefined) {
            this.errorMessageResource = data.message;
            this.errorMessageResourceActive = true;
            this.diResourceSuccess = false;
            this.spinnerService.hide();
            setTimeout(() => {
              window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
            }, 200);
          } else if (data !== undefined) {
            this.errorMessageResourceActive = false;
            this.diResourceSuccess = true;
            this.deleteResource = false;

            this.getDiResouceList();
            this.getDiFolderList();
            setTimeout(() => {
              window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
            }, 200);
            this.spinnerService.hide();
          }
        });


      }
    }
    //if save condition
    else {

      this.spinnerService.show();
      this.diService.diAddResource(diData).subscribe(data => {
        this.resourceData = data;
        if (data.message !== undefined) {
          this.errorMessageResource = data.message;
          this.errorMessageResourceActive = true;
          this.diResourceSuccess = false;
          this.deleteResource = false;
          this.spinnerService.hide();
          setTimeout(() => {
            window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
          }, 300);
        }
        else if (data !== undefined) {
          this.spinnerService.show();
          this.uploadFlag = 'resource';
          if (this.selectedFile != null) {
            this.bpgCommonService.getAwsUrl(uploadData).subscribe(async data => {
              this.awsUrls = data;
              await this.uploadService.getPresignedUrl(this.selectedFile, this.awsUrls, this.resourceData.diResourceId, this.uploadFlag);
              if (localStorage.getItem('uploadError') === 'Error') {
                const dleteData = {
                  "id": this.resourceData.diResourceId,
                  "flag": "resource"
                }
                this.diService.deleteDi(dleteData).subscribe(data => {
                  if (data.flag === "resource") {
                    this.errorMessageResourceActive = false;
                    this.errorMsgUploadSave = true;
                    this.diResourceSuccess = false;
                    this.getDiResouceList();
                    this.getDiFolderList();

                    setTimeout(() => {
                      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
                    }, 200);
                  }
                });
                this.spinnerService.hide();
                localStorage.removeItem('uploadError')
              }

              else {
                this.errorMessageResourceActive = false;
                this.diResourceSuccess = true;
                this.deleteResource = false;
                this.errorMsgUploadSave = false;
                this.getDiResouceList();
                this.getDiFolderList();
                setTimeout(() => {
                  window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
                }, 200);

              }
              this.spinnerService.hide();

            });


          }
        }
      });

    }
  }


  /** to submit ReTeam
 * @class DIComponent
 * @method onReTeamSubmit
 */
  public onReTeamSubmit() {

    if (this.uploadFileExtensionUser === true) {
      this.removeModalReTeam();
      return;
    }
    if (this.saveAndUpdateReTeam === true) {
      this.setModalReTeam();
      this.popupModalReTeam()
      document.getElementById('UpdateReTeam').click();
    }
    else {
      this.setModalReTeam();
      this.popupModalReTeam()
      document.getElementById('saveReTeam').click();
    }

  }


  popupModalReTeam() {
    if (this.saveAndUpdateReTeam === true) {
      this.method = "addReTeam";
      this.param = '';
      this.msg1 = this.msg1Constant;
    }
    else {
      this.method = "addReTeam";
      this.param = '';
      this.msg1 = this.msgConstant;
    }
  }

  setModalReTeam() {
    if (this.saveAndUpdateReTeam === true) {
      document.getElementById('UpdateReTeam').setAttribute(this.dataToggleConstant, 'modal');
      document.getElementById('UpdateReTeam').setAttribute(this.dataTargetConstant, '#myModal');
    } else {
      document.getElementById('saveReTeam').setAttribute(this.dataToggleConstant, 'modal');
      document.getElementById('saveReTeam').setAttribute(this.dataTargetConstant, '#myModal');
    }
  }
  removeModalReTeam() {
    if (this.saveAndUpdateReTeam === true) {
      document.getElementById('UpdateReTeam').removeAttribute(this.dataToggleConstant);
      document.getElementById('UpdateReTeam').removeAttribute(this.dataTargetConstant);
    }
    else {
      document.getElementById('saveReTeam').removeAttribute(this.dataToggleConstant);
      document.getElementById('saveReTeam').removeAttribute(this.dataTargetConstant);

    }
  }

  /** to save/edit reTeam
 * @class DIComponent
 * @method addReTeam
 */
  addReTeam() {
    if (this.saveAndUpdateReTeam === true) {
      this.reTeamFlag = "updateReTeam"

    }
    else {
      this.reTeamFlag = "saveReTeam"
    }

    this.siteNameList = [];
    if (this.siteName.length > 0) {

      for (const site of this.siteName) {
        if (site.siteName != null && site.siteName !== undefined){
          this.siteNameList.push(site.siteName);
        }
        else{
          this.siteNameList.push(site);
        }
      }
    }
    this.spinnerService.show();
    this.diUserImage = document.getElementById("base64textareaUser").textContent;
    const diData = {
      "userId": this.userId,
      "roleName": this.regionalDesignation,
      "emailId": this.emailId,
      "userPic": this.uploadFileNameUser,
      "id": this.loginDetails.userId,
      "regionalOrder": this.reTeamOrder,
      "diId": this.diMasterList[0].diId,
      "reTeamPic": this.diUserImage,
      "diReTeamId": this.diReTeamId,
      "reTeamFlag": this.reTeamFlag,
      "diPronounce": this.diPronoun,
      "siteNameList": this.siteNameList
    }
    this.diService.diReTeamAdd(diData).subscribe(data => {
      if (data.message !== undefined) {
        this.errorMessageRegional = data.message;
        this.errorMessageRegionalActive = true;
        this.diReteamSuccess = false;
        this.noUser = false;
        this.userFound = false;

      } else if (data !== undefined) {
        this.errorMessageRegionalActive = false;
        this.noUser = false;
        this.userFound = false;
        this.diReteamSuccess = true;
        this.deleteRegional = false;
        this.LandingPaginationDTO.searchTerm = '';
        this.getReteamList();
      } setTimeout(() => {
        window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
      }, 200);
      this.spinnerService.hide();

    })
  }


  /** to sumbit naac
 * @class DIComponent
 * @method onNaacSubmit
 */
  public onNaacSubmit() {
    if (this.uploadFileExtensionNaac === true) {
      
      this.removeModalNaac();
      return;
    }
    if (this.saveAndUpdateNaac === true) {
      this.setModalReTeamNaac();
      this.popupModalReTeamNaac()
      document.getElementById('UpdateNac').click();
    }
    else {
      this.setModalReTeamNaac();
      this.popupModalReTeamNaac()
      document.getElementById('saveNaac').click();
    }

  }

  popupModalReTeamNaac() {
    if (this.saveAndUpdateNaac === true) {
      this.method = "addNaac";
      this.param = '';
      this.msg1 = this.msg1Constant;
    }
    else {
      this.method = "addNaac";
      this.param = '';
      this.msg1 = " Are you sure you want to save ? ";
    }
  }

  setModalReTeamNaac() {
    if (this.saveAndUpdateNaac === true) {
      document.getElementById('UpdateNac').setAttribute(this.dataToggleConstant, 'modal');
      document.getElementById('UpdateNac').setAttribute(this.dataTargetConstant, '#myModal');
    } else {
      document.getElementById('saveNaac').setAttribute(this.dataToggleConstant, 'modal');
      document.getElementById('saveNaac').setAttribute(this.dataTargetConstant, '#myModal');
    }
  }

  removeModalNaac() {
    if (this.saveAndUpdateNaac === true) {
      document.getElementById('UpdateNac').removeAttribute(this.dataToggleConstant);
      document.getElementById('UpdateNac').removeAttribute(this.dataTargetConstant);
    }
    else {
      document.getElementById('saveNaac').removeAttribute(this.dataToggleConstant);
      document.getElementById('saveNaac').removeAttribute(this.dataTargetConstant);

    }
  }

  /** to save/edit naac
 * @class DIComponent
 * @method addNaac
 */
  addNaac() {

    if (this.saveAndUpdateNaac === true) {
      this.naacFlag = "saveNaac";
    }
    else {
      this.naacFlag = "updateNaac";
    }
    this.spinnerService.show();
    this.logoPathImage = document.getElementById("base64textareaNaac").textContent;
    const diData = {
      "diId": this.diMasterList[0].diId,
      "id": this.loginDetails.userId,
      "naacAffiliateName": this.naacName,
      "logoPath": this.uploadFileNameNaac,
      "sharepointLink": this.naacLink,
      "naacAffiliateId": this.naacId,
      "logoPathImage": this.logoPathImage,
      "naacFlag": this.naacFlag,
    }
    this.diService.diNaacAdd(diData).subscribe(data => {
      if (data !== undefined) {
        this.diNaacSuccess = true;
        this.deleteNaac = false;
        this.getNaacList();
      } setTimeout(() => {
        window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
      }, 200);
      this.spinnerService.hide();

    })

  }



  /** to reset news
   * @class DIComponent
   * @method resetNews
   */
  resetNews() {
    this.clearAlerts();
    this.method = "onResetNewsClick";
    this.param = '';
    this.msg1 = this.msg2Constant;
  }

  onResetNewsClick() {

    setTimeout(() => {
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    }, 200);
    this.deleteNews = false;
    this.deleteResetNews();
    this.getDiNewsList();

  }


  deleteResetNews() {
    this.diNewsSuccess = false;
    this.newsId = null;
    this.newsTitle = null
    this.newsDesc = null
    this.newsLink = null
    this.newsSearchKey = null
    this.saveNews = true;
    this.firstEditNews = true;
    this.saveAndUpdateNews = false;
    this.newsLinkValid = false
    this.LandingPaginationDTO.searchTerm = '';
    this.selectedFileNameforNews = this.fileTypeConstant;
    this.isUploadnewsImage = false;
    this.newsFile = null;
    this.newsfileName = '';
    this.newsExtensionError = false;
  }


  /** to reset resource
   * @class DIComponent
   * @method resetResource
   */
  resetResource() {
    this.clearAlerts();
    this.method = "onResetResourceClick";
    this.param = '';
    this.msg1 = this.msg2Constant;
  }

  onResetResourceClick() {
    setTimeout(() => {
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    }, 200);
    this.deleteResource = false;
    this.deleteResetResource();
    this.getDiResouceList();
    this.getDiFolderList();

  }

  deleteResetResource() {
    this.addResouceTitle = null
    this.additionalDesc = null
    this.addResourceDocument = null
    this.resourceOrder = null
    this.resourceSearchKey = null;
    this.LandingPaginationDTO.searchTerm = '';
    this.diResourceSuccess = false;
    this.diResourceId = '0';
    this.saveAndUpdateResource = false;
    this.saveResource = true;
    this.errorMessageResourceActive = false;
    this.ResourcefileName = "Upload document(< 500MB)";
    this.isFileUploded = false;
    this.selectedFile = null;
    this.fileSizeExtensionError = false;
    this.UploadDocument = null;
    this.errorMsgUploadSave = false;
    this.errorMsgUploadSaveUpdate = false;
    this.selectedFolder = null;
    this.folderName = '';
    this.folderId = null;
  }


  /** to reset reTeam
   * @class DIComponent
   * @method resetReTeam
   */
  resetReTeam() {
    this.clearAlerts();
    this.method = "onResetReTeamClick";
    this.param = '';
    this.msg1 = this.msg2Constant;

  }
  onResetReTeamClick() {
    setTimeout(() => {
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    }, 200);
    this.deleteRegional = false;
    this.myInputVariable.nativeElement.value = "";
    this.deleteResetReTeam();
    this.getReteamList();
    this.imageChangedEvent = '';
    this.croppedImage = '';
    this.uploadFileName = '';
    this.uploadFileExtensionUser = false;
    document.getElementById("base64textareaUser").textContent = '';
    document.getElementById("filenameUserPic").textContent = this.fileTypeConstant;
    this.myInputVariable.nativeElement.value = '';
    this.isUploadImage = false;
    this.isLoaderStop = false;
    this.diUserImage = null;
  }

  deleteResetReTeam() {
    this.userList = null;
    this.regionalDesignation = null
    this.userId = null
    this.userFirstName = null
    this.searchTerm = null
    this.emailId = null
    this.userPic = null
    this.reTeamOrder = null
    this.reTeamSearchKey = null;
    this.LandingPaginationDTO.searchTerm = '';
    this.diReteamSuccess = false;
    this.diUserImage = null;
    this.diReTeamId = '0';
    this.reTeamEamilValid = false;
    this.uploadFileExtensionUser = false
    this.errorMessageRegionalActive = false;
    this.diPronoun = '';
    if (this.lbl !== undefined) {
      this.lbl.innerText = "JPEG or PNG (400 x 200)";
    }
    document.getElementById("base64textareaUser").textContent = '';
    document.getElementById("filenameUserPic").textContent = "JPEG or PNG (400 x 200)";
    this.saveReTeam = true;
    this.saveAndUpdateReTeam = false;
    this.butDisabled = true
  }

  /** to reset naac
  * @class DIComponent
  * @method resetNaac
  */
  resetNaac() {
    this.clearAlerts();
    this.method = "onResetNaacClick";
    this.param = '';
    this.msg1 = this.msg2Constant;
  }

  onResetNaacClick() {
    setTimeout(() => {
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    }, 200);
    this.deleteNaac = false;
    this.deleteResetNaac();
    this.getNaacList();
  }

  deleteResetNaac() {
    this.naacName = null;
    this.naacLogo = null;
    this.naacLink = null;
    this.LandingPaginationDTO.searchTerm = '';
    this.naacSearchKey = null;
    this.diNaacSuccess = false;
    this.naacLinkValid = false;
    this.saveNaac = true;
    this.saveAndUpdateNaac = false;
    this.uploadFileExtensionNaac = false;
    if (this.lbl !== undefined) {
      this.lbl.innerText = "JPEG or PNG (80 x 60)";
    }
    document.getElementById("base64textareaNaac").textContent = '';
    document.getElementById("filenameNaac").textContent = "JPEG or PNG (80 x 60)";
  }

  /** action on click of di master tab
  * @class DIComponent
  * @method diMaster
  */
  diMaster() {
    setTimeout(() => {
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    }, 200);
    this.diMasterTable = true;
    this.diNewsTable = false;
    this.diResourceTable = false;
    this.diReTeamTable = false;
    this.diNaacTable = false;

    this.noNewsTable = false;
    this.noResourceTable = false;
    this.noReginalTbale = false;
    this.noNaacTable = false;

    this.diNewsSuccess = false;
    this.diResourceSuccess = false;
    this.diReteamSuccess = false;
    this.diNaacSuccess = false;

    this.deleteNews = false;
    this.deleteResource = false;
    this.deleteRegional = false;
    this.deleteNaac = false;
    this.errorMessageResourceActive = false;
    this.errorMessageRegionalActive = false;

    this.userFound = false;
    this.noUser = false
    this.LandingPaginationDTO.searchTerm = '';
    this.newsSearchKey = '';
    this.resourceSearchKey = '';
    this.reTeamSearchKey = '';
    this.naacSearchKey = '';
    this.searchTerm = '';
    this.errorMsgUploadSave = false;
    this.errorMsgUploadSaveUpdate = false;

  }

  /** action on click of di news tab
 * @class DIComponent
 * @method diMaster
 */
  diNews() {
    setTimeout(() => {
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    }, 200);
    this.currentPage = 1;
    this.LandingPaginationDTO.page = 0;
    this.diNewsTable = true;
    this.diMasterTable = false;
    this.diResourceTable = false;
    this.diReTeamTable = false;
    this.diNaacTable = false;

    this.noResourceTable = false;
    this.noReginalTbale = false;
    this.noNaacTable = false;

    this.diUpdateSuccess = false;
    this.diNewsSuccess = false;
    this.diUpdateSuccess = false;
    this.diReteamSuccess = false;
    this.diNaacSuccess = false;
    this.diResourceSuccess = false;

    this.deleteNews = false;
    this.deleteResource = false;
    this.deleteRegional = false;
    this.deleteNaac = false;

    this.userFound = false;
    this.noUser = false

    this.errorMessageResourceActive = false;
    this.errorMessageRegionalActive = false;

    this.LandingPaginationDTO.searchTerm = '';
    this.newsSearchKey = '';
    this.resourceSearchKey = '';
    this.reTeamSearchKey = '';
    this.naacSearchKey = '';
    this.searchTerm = '';
    this.errorMsgUploadSave = false;
    this.errorMsgUploadSaveUpdate = false;

    this.getDiNewsList();

  }

  /** get list of di news
  * @class DIComponent
  * @method getDiNewsList
  */
  getDiNewsList() {
    this.spinnerService.show();
    this.LandingPaginationDTO.size = ConstantValues.pageLimit;
    this.LandingPaginationDTO.sortDirection = "DESC";
    this.LandingPaginationDTO.sortProperty = "modifiedDateTime";

    this.diService.getDiNewsList(this.LandingPaginationDTO).subscribe(data => {
      this.diNewsList = data.content;
      if (this.diNewsList.length === 0) {
        this.noNewsTable = true;
      }
      else {
        this.noNewsTable = false;
        this.tableShow = true;
      }

      this.numberOfElements = data.totalElements;
      this.spinnerService.hide();
      if ((this.currentPage * this.limit) < this.numberOfElements) {
        this.currentShowingElementsNews = this.currentPage * this.limit;
      } else if ((this.currentPage * this.limit) >= this.numberOfElements) {

        this.currentShowingElementsNews = this.numberOfElements;
      }
    })

  }


  /** action on click of di resource tab
  * @class DIComponent
  * @method diResource
  */
  diResource() {
    setTimeout(() => {
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    }, 200);
    this.currentPage = 1;
    this.LandingPaginationDTO.page = 0;
    this.diNewsTable = false;
    this.diMasterTable = false;
    this.diResourceTable = true;
    this.diReTeamTable = false;
    this.diNaacTable = false;

    this.noNewsTable = false
    this.noReginalTbale = false;
    this.noNaacTable = false;

    this.diUpdateSuccess = false;
    this.diNewsSuccess = false;
    this.diUpdateSuccess = false;
    this.diReteamSuccess = false;
    this.diNaacSuccess = false;

    this.deleteNews = false;
    this.deleteResource = false;
    this.deleteRegional = false;
    this.deleteNaac = false;

    this.userFound = false;
    this.noUser = false
    this.errorMessageRegionalActive = false;
    this.LandingPaginationDTO.searchTerm = '';
    this.newsSearchKey = '';
    this.resourceSearchKey = '';
    this.reTeamSearchKey = '';
    this.naacSearchKey = '';
    this.searchTerm = '';

    this.getDiResouceList();
    this.getDiFolderList();
    this.errorMsgUploadSave = false;
    this.errorMsgUploadSaveUpdate = false;

  }

  /** get list of di resource
  * @class DIComponent
  * @method getDiResouceList
  */
  getDiResouceList() {
    this.spinnerService.show()
    this.LandingPaginationDTO.size = ConstantValues.pageLimit;
    this.LandingPaginationDTO.sortDirection = "ASC";
    this.LandingPaginationDTO.sortProperty = "folderOrder";
    this.LandingPaginationDTO.filter = { "diFlag": "diSelfService" }
    this.diService.getDiResouceList(this.LandingPaginationDTO).subscribe(data => {
      this.diResouceList = data.content;

      if (this.diResouceList.length === 0) {
        this.noResourceTable = true
      }
      else {
        this.noResourceTable = false
        this.tableShow = true;

      }
      this.numberOfElements = data.totalElements;
      this.spinnerService.hide();
      if ((this.currentPage * this.limit) < this.numberOfElements) {
        this.currentShowingElementsResource = this.currentPage * this.limit;
      } else if ((this.currentPage * this.limit) >= this.numberOfElements) {

        this.currentShowingElementsResource = this.numberOfElements;
      }
    })

  }

  /** get list of di Folders
* @class DIComponent
* @method getDiFolderList
*/
  getDiFolderList() {
    this.landingData = {
      "filter": {},
      "moduleId": 0,

      "presentRole": "",
      "searchTerm": "",
      "size": 50,
      "sortDirection": "DESC",
      "sortProperty": "created_date_time",
      "uid": ""
    }

    this.userService.getDiDocumentsFolder(this.landingData).subscribe(data => {
      this.folderNameList = data.content;

    })
  }


  /** action on click of di reTeam tab
  * @class DIComponent
  * @method diReTeam
  */
  diReTeam() {
    setTimeout(() => {
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    }, 200);
    this.currentPage = 1;
    this.LandingPaginationDTO.page = 0;


    this.diNewsTable = false;
    this.diMasterTable = false;
    this.diResourceTable = false;
    this.diReTeamTable = true;
    this.diNaacTable = false;

    this.noResourceTable = false;
    this.noNewsTable = false;
    this.noNaacTable = false;
    this.noReginalTbale = false;

    this.diUpdateSuccess = false;
    this.diNewsSuccess = false;
    this.diReteamSuccess = false;
    this.diNaacSuccess = false;
    this.diResourceSuccess = false;

    this.deleteNews = false;
    this.deleteResource = false;
    this.deleteRegional = false;
    this.deleteNaac = false;

    this.errorMessageResourceActive = false;

    this.LandingPaginationDTO.searchTerm = '';
    this.newsSearchKey = '';
    this.resourceSearchKey = '';
    this.reTeamSearchKey = '';
    this.naacSearchKey = '';
    this.searchTerm = '';
    this.errorMsgUploadSave = false;
    this.errorMsgUploadSaveUpdate = false;

    this.getReteamList();

  }


  /** get list of di Reteam
   * @class DIComponent
   * @method getReteamList
   */
  getReteamList() {
    if (this.searchTerm != null && (this.reTeamSearchKey === null || this.reTeamSearchKey === '')) {
      this.LandingPaginationDTO.searchTerm = '';
    }
    this.spinnerService.show();

    this.LandingPaginationDTO.size = ConstantValues.pageLimit;
    this.LandingPaginationDTO.sortDirection = "ASC";
    this.LandingPaginationDTO.sortProperty = "regionalOrder";
    this.LandingPaginationDTO.filter = { "diFlag": "diSelfService" }

    this.diService.getReteamList(this.LandingPaginationDTO).subscribe(data => {
      this.diReTeamList = data.content;
      if (this.diReTeamList.length === 0) {
        this.noReginalTbale = true;
        this.tableShow = true;
      }
      else {
        this.noReginalTbale = false

      }
      this.numberOfElements = data.totalElements;
      if ((this.currentPage * this.limit) < this.numberOfElements) {
        this.currentShowingElementsReTeam = this.currentPage * this.limit;
      } else if ((this.currentPage * this.limit) >= this.numberOfElements) {

        this.currentShowingElementsReTeam = this.numberOfElements;
      }
    })
    this.spinnerService.hide();

  }


  /** action on click of di naac tab
  * @class DIComponent
  * @method diNaac
  */
  diNaac() {
    setTimeout(() => {
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    }, 200);

    this.currentPage = 1;
    this.LandingPaginationDTO.page = 0;
    this.diNewsTable = false;
    this.diMasterTable = false;
    this.diResourceTable = false;
    this.diReTeamTable = false;
    this.diNaacTable = true;

    this.noNewsTable = false;
    this.noResourceTable = false;
    this.noReginalTbale = false;

    this.diUpdateSuccess = false;
    this.diNewsSuccess = false;
    this.diReteamSuccess = false;
    this.diNaacSuccess = false;
    this.diResourceSuccess = false;

    this.deleteNews = false;
    this.deleteResource = false;
    this.deleteRegional = false;
    this.deleteNaac = false;

    this.errorMessageResourceActive = false;
    this.errorMessageRegionalActive = false;
    this.LandingPaginationDTO.searchTerm = '';
    this.newsSearchKey = '';
    this.resourceSearchKey = '';
    this.reTeamSearchKey = '';
    this.naacSearchKey = '';
    this.searchTerm = '';

    this.userFound = false;
    this.noUser = false;
    this.errorMsgUploadSave = false;
    this.errorMsgUploadSaveUpdate = false;

    this.getNaacList();

  }

  /** get list of di naac
  * @class DIComponent
  * @method getNaacList
  */
  getNaacList() {
    this.spinnerService.show();
    this.LandingPaginationDTO.size = ConstantValues.pageLimit;
    this.LandingPaginationDTO.sortDirection = "ASC";
    this.LandingPaginationDTO.sortProperty = "naacAffiliateName";
    this.LandingPaginationDTO.filter = { "diFlag": "diSelfService" }

    this.diService.getNaacList(this.LandingPaginationDTO).subscribe(data => {
      this.naacAffiliateList = data.content;

      if (this.naacAffiliateList.length === 0) {
        this.noNaacTable = true;
        this.tableShow = true;
      }
      else {
        this.noNaacTable = false

      }
      this.numberOfElements = data.totalElements;
      this.spinnerService.hide();
      if ((this.currentPage * this.limit) < this.numberOfElements) {
        this.currentShowingElementsNaac = this.currentPage * this.limit;
      } else if ((this.currentPage * this.limit) >= this.numberOfElements) {

        this.currentShowingElementsNaac = this.numberOfElements;
      }

    })
  }


  /** to select the banner image
  * @class DIComponent
  * @method onDiBannerSelected
  */
  onDiBannerSelected(event) {
    const files = event.target.files;
    const file = files[0];
    this.uploadFileName = file.name;
    if (file.type !== "image/png" && file.type !== this.fileType1Constant) {
      this.uploadFileExtensionBanner = true;
    } else {
      this.uploadFileExtensionBanner = false;
    }
    const image: any = event.target.files[0];
    const fr: any = new FileReader();
    fr.onload = () => { // when file has loaded
      const img = new Image();
      img.onload = () => {
        this.width = img.width;
        this.height = img.height;
        if (this.width < 1366) {
          this.uploadFileExtensionBanner = true;
        } else {
          this.uploadFileExtensionBanner = false;
        }
      };
      img.src = fr.result; // This is the data URL

    };
    fr.readAsDataURL(image);



    this.lbl2 = document.getElementById('filenameBanner');
    this.lbl2.innerText = this.uploadFileName;
    if (files && file) {
      this.diNaacBannerImage = "";
      let imageData = '';
      const reader: any = new FileReader();
      if (reader.readAsBinaryString) {
        reader.onloadend = function (readerEvt) {
          const binaryString = readerEvt.target.result;
          imageData = btoa(binaryString);
          document.getElementById("base64textarea").textContent = imageData;
        };
        this.diNaacBannerImage = imageData;
        reader.readAsBinaryString(file);
      } else { //IE 10 or 11
        let binary = "";
        reader.onload = function (e) {
          const bytes = new Uint8Array(e.target.result);
          const length = bytes.byteLength;
          for (let i = 0; i < length; i++) {
            binary += String.fromCharCode(bytes[i]);
          }
          //binary - readonly so assign content to another property
          imageData = btoa(binary);
          document.getElementById("base64textarea").textContent = imageData;
        }
        this.diNaacBannerImage = imageData;

        reader.readAsArrayBuffer(file);
      }
    }
  }
  findbyEmail(e){
    const text = e.target.value;
    if(text.length>2){
     this.searchTerm = text;
     this.searchBy();
    }else{
      this.userList = [];
    }
  }

  /** to select the user pic
   * @class DIComponent
   * @method onUserPicSelected
   */
  onUserPicSelected(event) {
    const files = event.target.files;
    const file = files[0];
    this.uploadFileNameUser = file.name;
    if (this.width === 400 && this.height === 400) {
      this.uploadFileExtensionUser = false;
    } else {
      this.uploadFileExtensionUser = true;
    }
    const image: any = event.target.files[0];
    const fr: any = new FileReader();
    fr.onload = () => { // when file has loaded
      const img = new Image();
      img.onload = () => {
        this.width = img.width;
        this.height = img.height;
        if (this.width === 400 && this.height === 400) {
          this.uploadFileExtensionUser = false;
        } else {
          this.uploadFileExtensionUser = true;
        }
      };
      img.src = fr.result; // This is the data URL

    };
    fr.readAsDataURL(image);

    this.lbl = document.getElementById('filenameUserPic');
    this.lbl.innerText = this.uploadFileNameUser;
    if (files && file) {
      this.diUserImage = "";
      let imageData: any = '';
      const reader: any = new FileReader();
      if (reader.readAsBinaryString) {
        reader.onloadend = function (readerEvt) {
          const binaryString = readerEvt.target.result;
          imageData = btoa(binaryString);
          document.getElementById("base64textareaUser").textContent = imageData;
        };
        this.diUserImage = imageData;
        reader.readAsBinaryString(file);
      } else { //IE 10 or 11
        let binary = "";
        reader.onload = function (e) {
          const bytes = new Uint8Array(e.target.result);
          const length = bytes.byteLength;
          for (let i = 0; i < length; i++) {
            binary += String.fromCharCode(bytes[i]);
          }
          //binary - readonly so assign content to another property
          imageData = btoa(binary);
          document.getElementById("base64textareaUser").textContent = imageData;
        }
        this.diUserImage = imageData;
        reader.readAsArrayBuffer(file);
      }
    }
  }

  /** to select the naac logo
    * @class DIComponent
    * @method onNaacSelected
    */
  onNaacSelected(event) {
    const files = event.target.files;
    const file = files[0];
    this.uploadFileNameNaac = file.name;
    if (file.type !== "image/png" && file.type !== this.fileType1Constant) {
      this.uploadFileExtensionNaac = true;
    } else {
      this.uploadFileExtensionNaac = false;
    }
    const image: any = event.target.files[0];
    const fr: any = new FileReader();
    fr.onload = () => { // when file has loaded
      const img = new Image();
      img.onload = () => {
        this.width = img.width;
        this.height = img.height;
        if (this.width > 80) {
          this.uploadFileExtensionNaac = true;
        } else {
          this.uploadFileExtensionNaac = false;
        }
      };
      img.src = fr.result; // This is the data URL

    };
    fr.readAsDataURL(image);

    this.lbl = document.getElementById('filenameNaac');
    this.lbl.innerText = this.uploadFileNameNaac;
    if (files && file) {
      this.logoPathImage = "";
      let imageData: any = '';
      const reader: any = new FileReader();
      if (reader.readAsBinaryString) {
        reader.onloadend = function (readerEvt) {
          const binaryString = readerEvt.target.result;
          imageData = btoa(binaryString);
          document.getElementById("base64textareaNaac").textContent = imageData;
        };
        this.logoPathImage = imageData;
        reader.readAsBinaryString(file);
      } else { //IE 10 or 11
        let binary = "";
        reader.onload = function (e) {
          const bytes = new Uint8Array(e.target.result);
          const length = bytes.byteLength;
          for (let i = 0; i < length; i++) {
            binary += String.fromCharCode(bytes[i]);
          }
          //binary - readonly so assign content to another property
          imageData = btoa(binary);
          document.getElementById("base64textareaNaac").textContent = imageData;
        }
        this.logoPathImage = imageData;
        reader.readAsArrayBuffer(file);
      }
    }
  }

  /** on news page changed
    * @class DIComponent
    * @method onNaacSelected
    */
  pageNewsChanged(event) {
    this.LandingPaginationDTO.page = event - 1;
    this.currentPage = event;
    if ((this.currentPage * this.limit) < this.numberOfElements) {
      this.currentShowingElementsNews = this.currentPage * this.limit;
    } else if ((this.currentPage * this.limit) >= this.numberOfElements) {
      this.currentShowingElementsNews = this.numberOfElements;
    }
    this.getDiNewsList();
  }

  /** on resource page changed
  * @class DIComponent
  * @method pageResourceChanged
  */
  pageResourceChanged(event) {
    this.LandingPaginationDTO.page = event - 1;
    this.currentPage = event;
    if ((this.currentPage * this.limit) < this.numberOfElements) {
      this.currentShowingElementsResource = this.currentPage * this.limit;
    } else if ((this.currentPage * this.limit) >= this.numberOfElements) {
      this.currentShowingElementsResource = this.numberOfElements;
    }
    this.getDiResouceList();
    this.getDiFolderList();
  }

  /** on reTeam page changed
 * @class DIComponent
 * @method pageReteamChanged
 */
  pageReteamChanged(event) {
    this.LandingPaginationDTO.page = event - 1;
    this.currentPage = event;
    if ((this.currentPage * this.limit) < this.numberOfElements) {
      this.currentShowingElementsReTeam = this.currentPage * this.limit;
    } else if ((this.currentPage * this.limit) >= this.numberOfElements) {
      this.currentShowingElementsReTeam = this.numberOfElements;
    }
    this.getReteamList();
  }

  /** on naac page changed
 * @class DIComponent
 * @method pageNaacChanged
 */
  pageNaacChanged(event) {
    this.LandingPaginationDTO.page = event - 1;
    this.currentPage = event;
    if ((this.currentPage * this.limit) < this.numberOfElements) {
      this.currentShowingElementsNaac = this.currentPage * this.limit;
    } else if ((this.currentPage * this.limit) >= this.numberOfElements) {
      this.currentShowingElementsNaac = this.numberOfElements;
    }
    this.getNaacList();
  }

  /** For searching the user
 * @class DIComponent
 * @method searchBy
 */

  searchBy() {
    this.clearAlerts();
    this.spinnerService.show();
    this.search = true;
    this.searchTerm = (this.searchTerm) ? this.searchTerm : '';
    this.LandingPaginationDTO.searchTerm = this.searchTerm;
    this.getUserList();
    this.spinnerService.hide();
  }

  /** For searching the news
 * @class DIComponent
 * @method searchNewsMe
 */
  searchNewsMe() {
    this.clearAlerts();
    this.spinnerService.show();
    this.newsSearchKey = (this.newsSearchKey) ? this.newsSearchKey : '';
    this.LandingPaginationDTO.page = 0;
    this.LandingPaginationDTO.searchTerm = this.newsSearchKey;
    this.currentPage = 1;
    this.getDiNewsList();
    this.spinnerService.hide();
  }


  /** For searching the resource
 * @class DIComponent
 * @method searchResourceMe
 */
  searchResourceMe() {
    this.clearAlerts();
    this.spinnerService.show();
    this.resourceSearchKey = (this.resourceSearchKey) ? this.resourceSearchKey : '';
    this.LandingPaginationDTO.page = 0;
    this.LandingPaginationDTO.searchTerm = this.resourceSearchKey;
    this.currentPage = 1;
    this.getDiResouceList();
    this.getDiFolderList();
    this.spinnerService.hide();
  }


  /** For searching the reTeam
 * @class DIComponent
 * @method searchReTeamMe
 */
  searchReTeamMe() {
    this.clearAlerts();
    this.spinnerService.show();
    this.reTeamSearchKey = (this.reTeamSearchKey) ? this.reTeamSearchKey : '';
    this.LandingPaginationDTO.page = 0;
    this.LandingPaginationDTO.searchTerm = this.reTeamSearchKey;
    this.currentPage = 1;
    this.getReteamList();
    this.spinnerService.hide();
  }

  /** For searching the Naac
 * @class DIComponent
 * @method searchNaacMe
 */
  searchNaacMe() {
    this.clearAlerts();
    this.spinnerService.show();
    this.naacSearchKey = (this.naacSearchKey) ? this.naacSearchKey : '';
    this.LandingPaginationDTO.page = 0;
    this.LandingPaginationDTO.searchTerm = this.naacSearchKey;
    this.currentPage = 1;
    this.getNaacList();
    this.spinnerService.hide();
  }

  /** to Delete di
* @class DIComponent
* @method deleteDi
*/
  public deleteDi(id, flag, i) {
    document.getElementById('deleteDi' + i).setAttribute(this.dataToggleConstant, 'modal');
    document.getElementById('deleteDi' + i).setAttribute(this.dataTargetConstant, '#myModal');
    this.method = "deleteAllDi";
    this.param = id;
    this.param1 = flag;
    this.msg1 = "  Are you sure you want to delete ? ";
  }
  /** to Delete gallery
* @class ConfigureGalleryComponent
* @method deleteGallery
*/
  deleteBanner(id) {
    this.spinnerService.show();
    this.userService.deleteBannerList(id).subscribe(_data => {
      this.spinnerService.hide();
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
      this.deleteSuccess = true;
      this.diUpdateSuccess = false;
      this.getdiBannerList();

    });
  }
  /** confirmation to delete gallery
 * @class deleteBannerConfirmation
 * @method deleteBannerConfirmation
 */
  public deleteBannerConfirmation(id) {

    this.method = "deleteBanner";
    this.param = id;
    this.msg1 = "  Are you sure you want to delete ? ";
  }

  deleteAllDi(id, flag) {
    const dleteData = {
      "id": id,
      "flag": flag
    }

    this.diService.deleteDi(dleteData).subscribe(data => {
      if (data.flag === "news") {
        this.deleteNews = true
        this.deleteResetNews();
        this.getDiNewsList();
        setTimeout(() => {
          window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        }, 200);
      }
      else if (data.flag === "resource") {
        this.deleteResource = true;
        this.deleteResetResource();
        this.getDiResouceList();
        this.getDiFolderList();
        setTimeout(() => {
          window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        }, 200);
      }
      else if (data.flag === "regional") {
        this.deleteRegional = true;
        this.deleteResetReTeam();
        this.getReteamList();
        setTimeout(() => {
          window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        }, 200);
      }
      else {
        this.deleteNaac = true;
        this.deleteResetNaac();

        this.getNaacList();
        setTimeout(() => {
          window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        }, 200);
      }

    })

  }


  /** to edit news
* @class DIComponent
* @method editNews
*/
  editNews(data, i) {
    if (this.newsTitle != null || this.newsLink != null) {
      this.firstEditNews = false;
    }
    if (this.firstEditNews === true) {
      this.firstEditNews = false;
      this.editNewsData(data);
    } else {
      document.getElementById('editN' + i).setAttribute(this.dataToggleConstant, 'modal');
      document.getElementById('editN' + i).setAttribute(this.dataTargetConstant, '#myModal');
      this.method = "editNewsData";
      this.param = data;
      this.msg1 = this.msg2Constant;
    }
  }

  editNewsData(data) {
    this.newsTitle = data.diNewsTitle;
    this.newsDesc = data.diNewsDesc;
    this.newsLink = data.diNewsLink;
    this.newsId = data.diNewsId;
    this.isUploadnewsImage = data.imageCheck;
    this.deleteNews = false;
    this.newsExtensionError = false;
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    this.saveNews = false;
    this.saveAndUpdateNews = true;
    this.diNewsSuccess = false;
    this.selectedFileNameforNews = data.diNewsName.length > 13 ? data.diNewsName.substring(13,) : this.fileTypeConstant;
    if (!this.isUploadnewsImage){
      this.selectedFileNameforNews = this.fileTypeConstant
    }
  }

  /** to edit resource
  * @class DIComponent
  * @method editResource
  */
  editResource(data, i) {
    if (this.addResouceTitle != null || this.addResourceDocument != null) {
      this.firstEditResource = false;
    }
    if (this.firstEditResource === true) {
      this.firstEditResource = false;
      this.editResourceData(data);
    } else {
      document.getElementById('editR' + i).setAttribute(this.dataToggleConstant, 'modal');
      document.getElementById('editR' + i).setAttribute(this.dataTargetConstant, '#myModal');
      this.method = "editResourceData";
      this.param = data;
      this.msg1 = this.msg2Constant;
    }
  }

  editResourceData(data) {
    this.errorMsgUploadSaveUpdate = false;
    this.errorMsgUploadSave = false;
    this.isFileUploded = true;
    this.addResouceTitle = data.diResourceTitle;
    this.additionalDesc = data.diResourceDesc;
    this.ResourcefileName = data.diResourceDocument
    this.resourceOrder = data.resourceOrder;
    this.diResourceId = data.diResourceId;
    this.selectedFile = null;
    this.UploadDocument = data.diResourceDocument;
    this.selectedFolder = data.folderId;
    this.folderName = data.folderName;
    this.folderId = data.folderId;
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    this.saveResource = false;
    this.saveAndUpdateResource = true;
    this.diResourceSuccess = false;
  }

  /** to edit reTeam
  * @class DIComponent
  * @method editReTeam
  */
  editReTeam(data, i) {
    if (this.regionalDesignation != null || this.emailId != null) {
      this.firstEditReTeam = false;
    }
    if (this.firstEditReTeam === true) {
      this.firstEditReTeam = false;
      this.editReTeamData(data);
    } else {
      document.getElementById('editRt' + i).setAttribute(this.dataToggleConstant, 'modal');
      document.getElementById('editRt' + i).setAttribute(this.dataTargetConstant, '#myModal');
      this.method = "editReTeamData";
      this.param = data;
      this.msg1 = this.msg2Constant;
    }
  }

  editReTeamData(data) {
    this.butDisabled = false;
    this.noUser = false;
    this.userFound = false;
    this.showReset = true;
    this.searchTerm = null

    this.RePic = document.getElementById('filenameUserPic');
    this.uploadFileNameUser = data.userPic;
    if (this.uploadFileNameUser != null && this.uploadFileNameUser !== undefined && this.uploadFileNameUser.trim() !== "") {
      const b = this.uploadFileNameUser;
      this.RePic.innerText = b;
    }
    this.diUserImage = '';
    this.userFirstName = data.userName;
    this.regionalDesignation = data.roleName;
    this.emailId = data.emailId;
    this.userPic = data.userPic;
    this.reTeamOrder = data.regionalOrder;
    this.diReTeamId = data.diReTeamId;
    this.userId = data.userId;
    this.diPronoun = data.diPronounce;
    this.siteName = '';
    if (data.siteName.length > 0) {
      this.siteName = data.siteNameList;
    }
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    this.saveReTeam = false;
    this.saveAndUpdateReTeam = true;
    this.diReteamSuccess = false;
  }

  /** to edit naac
  * @class DIComponent
  * @method editNaac
  */
  editNaac(data, i) {
    if (this.naacName != null || this.naacLogo != null) {
      this.firstEditNaac = false;
    }
    if (this.firstEditNaac === true) {
      this.firstEditNaac = false;
      this.editNaacData(data);
    } else {
      document.getElementById('editN' + i).setAttribute(this.dataToggleConstant, 'modal');
      document.getElementById('editN' + i).setAttribute(this.dataTargetConstant, '#myModal');
      this.method = "editNaacData";
      this.param = data;
      this.msg1 = this.msg2Constant;
    }
  }

  editNaacData(data) {
    this.showReset = true;
    this.naacLog = document.getElementById('filenameNaac');
    this.uploadFileNameNaac = data.logoPath;
    if (this.uploadFileNameNaac != null && this.uploadFileNameNaac !== undefined && this.uploadFileNameNaac.trim() !== "") {
      const b = this.uploadFileNameNaac;
      this.naacLog.innerText = b;
    }

    this.naacName = data.naacAffiliateName;
    this.naacLogo = data.logoPath;
    this.naacLink = data.sharepointLink;

    this.naacId = data.naacAffiliateId;
    this.logoPathImage = ''
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    this.saveNaac = false;
    this.saveAndUpdateNaac = true;
    this.diNaacSuccess = false;
  }

  /** link validation
* @class DIComponent
* @method onLinkType
*/
  onLinkType(event, type) {
    const re = /^(https?:\/\/)?(www.\.)?[a-zA-Z0-9.-]+\.[a-zA-Z]{2,5}[.]?/;
    if (re.test(String(event.target.value).toLowerCase()) === false) {
      if (type === 'news') {
        if (event.target.value !== "") {
          this.newsLinkValid = true;
        }
      }
      else if (type === 'naac') {
        if (event.target.value !== "") {
          this.naacLinkValid = true;
        }
        else {
          this.naacLinkValid = false;
        }
      }
    }
    else if(type === 'news'){
      this.newsLinkValid = false;
    } else if(type === 'naac'){
      this.naacLinkValid = false;
    }
  }


  /** email validation
* @class DIComponent
* @method onEmailType
*/
  onEmailType(event) {
    const re = new RegExp(/^(?!\.)[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@(?!-)[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+$/);
    if (re.test(String(event.target.value).toLowerCase()) === false) {

      if (this.butDisabled === false) {
        this.reTeamEamilValid = true;
      }
    }
    else {
      this.reTeamEamilValid = false;
    }
  }
  public onFileSelectedNews(event) {
    this.isUploadnewsImage = true;
    this.newsFile = event.target.files[0] as File;
    this.selectedFileNameforNews = this.newsFile.name;
    this.newsfileName = this.selectedFileNameforNews;
    this.newsExtensionError = false;
    if (event.target.files[0].type !== "image/png" && (event.target.files[0].type !== this.fileType1Constant)) {
      this.newsExtensionError = true;

    }
  }
  /** checks if word exists in array
 * @class ConfigureGalleryComponent
 * @method isInArray
 */
  isInArray(array, word) {
    return array.indexOf(word.toLowerCase()) > -1;
  }


  /** on resource file selected
* @class DIComponent
* @method onFileSelected
*/
  public onFileSelected(event) {
    this.isFileUploded = true;
    if (event.target.files.length > 0) {
      this.ResourcefileName = event.target.files[0].name;
      this.fileSize = event.target.files[0].size;
      this.fileExtension = this.ResourcefileName.split('.').pop();
      //104857600  524288000
      if (this.fileSize >= 524288000) {
        this.fileSizeExtensionError = true;
      } else {
        this.fileSizeExtensionError = false;
        this.selectedFile = event.target.files[0] as File;
        this.UploadDocument = this.selectedFile.name;
      }

    }
  }

  fileChangeEvent(event: any, imageType): void {
    const files = event.target.files;
    const file = files[0];
    this.imageTypeName = imageType;
    if (file.type !== "image/png" && file.type !== this.fileType1Constant) {
      if (this.imageTypeName === 'userPic') {
        this.uploadFileExtensionUser = true;
        this.myInputVariable.nativeElement.value = '';
      } else if (this.imageTypeName === 'bannerImage') {
        this.uploadFileExtensionBanner = true;
        this.myInputBannerVariable.nativeElement.value = '';
      }
    }
    else {
      this.imageChangedEvent = event;
      if (this.imageTypeName === 'userPic') {
        this.uploadFileExtensionUser = false;
        this.uploadFileNameUser = file.name;
        document.getElementById("filenameUserPic").textContent = this.uploadFileNameUser;
        this.isLoaderUserPicStop = false;
        this.uploadUserPicImageDone = true;
        this.isUploadUserPicImage = true;
      } else if (this.imageTypeName === 'bannerImage') {
        this.uploadFileName = file.name;
        this.uploadFileExtensionBanner = false;
        document.getElementById("filenameBanner").textContent = this.uploadFileName;
        this.isLoaderStop = false;
        this.uploadImageDone = true;
        this.isUploadImage = true;
      } 
    }
  }
  imageCropped(event: ImageCroppedEvent) {

    this.croppedImage = event.base64.replace(/^data:image\/[a-z]+;base64,/, "");
    if (this.imageTypeName === 'userPic') {
      document.getElementById("base64textareaUser").textContent = this.croppedImage;
      this.diUserImage = this.croppedImage;
      this.uploadUserPicImageDone = true;
    } else if (this.imageTypeName === 'bannerImage') {
      document.getElementById("base64textarea").textContent = this.croppedImage;
      this.diBannerImage = this.croppedImage;
      this.uploadImageDone = true;
    } 
  }



  imageLoaded() {

    if (this.imageTypeName === 'userPic') {
      this.isLoaderUserPicStop = true;
    } else if (this.imageTypeName === 'bannerImage') {
      this.isLoaderStop = true;
    } else if (this.imageTypeName === 'news') {
      this.isLoadernewsImageStop = true;
    } 
    // show cropper
  }
  cropperReady() {
    // cropper ready
  }
  loadImageFailed() {
    // show message
  }

  cancelUploadedImage(imageType) {

    if (imageType === 'userPic') {
      document.getElementById("base64textareaUser").textContent = '';
      document.getElementById("filenameUserPic").textContent = this.fileTypeConstant;
      this.myInputVariable.nativeElement.value = '';
      this.uploadFileExtensionUser = false;
      this.diUserImage = null;
      this.uploadFileNameUser = null;
      this.isUploadUserPicImage = false;
      this.isLoaderUserPicStop = false;
      this.isLoadernewsImageStop = false;
    } else if (imageType === 'bannerImage') {
      document.getElementById("base64textarea").textContent = '';
      document.getElementById("filenameBanner").textContent = this.fileTypeConstant;
      this.myInputBannerVariable.nativeElement.value = '';
      this.uploadFileExtensionBanner = false;
      this.diBannerImage = null;
      this.uploadFileName = null;
      this.isUploadImage = false;
      this.isLoaderStop = false;
      this.uploadImageDone = false;
    } else if (imageType === 'news') {
      this.isUploadnewsImage = false;
    } 
    this.imageChangedEvent = '';
    this.croppedImage = '';
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
  }

  doneUploadedImage(imageType) {
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    if (imageType === 'userPic') {
      this.myInputVariable.nativeElement.value = '';
      this.uploadFileExtensionUser = false;
      this.uploadUserPicImageDone = false;
      this.isLoaderUserPicStop = false;
      this.isUploadUserPicImage = false;
    } else if (imageType === 'bannerImage') {
      this.myInputBannerVariable.nativeElement.value = '';
      this.uploadFileExtensionBanner = false;
      this.isUploadImage = false;
      this.uploadImageDone = true;
      this.isLoaderStop = false;
    } else if (imageType === 'news') {
      this.isUploadnewsImage = false;
      this.isLoadernewsImageStop = false;
    }
   
  }

  logUserAction() {
    const data = {
      userId : this.loginUserId,
      categoryDescription : "D+I Screen"
    };
    this.bpgCommonService.logUserAction(data).subscribe(
      (_data) => {});
  }

}

